export default __webpack_public_path__ + "static/media/platformDeviceIcon1.b7c2b4e0.webp";